<template>
  <div>
    <form
      class="form form-horizontal"
      role="form"
      @submit.prevent="saveVendor"
      id="ma-form"
      name="myForm"
      novalidate
    >
      <modal>
        <div slot="header">
          <button type="button" class="close" @click="CloseModal">&times;</button>
          <h2 class="modal-title">{{VENDOR.Name}}</h2>
        </div>

        <div slot="body">
          <div v-if="success_message != '' && success_message!=null">
            <div class="alert alert-success text-center">
              <strong>{{success_message}}</strong>
            </div>
          </div>
          <div v-if="Commodity_message!=null && Commodity_message!=''">
            <div class="alert alert-danger text-center">
              <strong>{{Commodity_message}}</strong>
            </div>
          </div>
          <div v-if="message !=null && message!=''">
            <div class="alert alert-danger text-center">
              <strong>{{message}}</strong>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-12">
              <label>Commodity</label>
              <select
                class="form-control"
                name="commodity"
                v-model="selectedCommodity"
                @change="addVendorCommodities"
              >
                <option
                  v-for="(option,index) in commodities"
                  :key="index"
                  :value="option.Id"
                >{{ option.Name }}</option>
              </select>
            </div>
          </div>
          <div class="form-group">
            <ul class="ul-row">
              <li class="li-row" v-for="(option,index) in AddedCommodity" :key="index">
                {{(index + 1) }}. {{option.Name}}
                <span
                  class="pull-right"
                  @click="removeCommodity(option)"
                >
                  <i class="glyphicon glyphicon-remove"></i>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div slot="footer">
          <loading v-if="loading"></loading>
          <input type="submit" value="Save" class="btn btn-primary" />
          <button class="btn btn-warning" @click="CloseModal">Cancel</button>
        </div>
      </modal>
    </form>
  </div>
</template>
<script>
import * as ACTIONS from "../../store/actions";
import { mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      success_message: null,
      title: "Commodiy ",
      Commodity_message: null,
      AddedCommodity: [],
      selectedCommodity: null
    };
  },
  props: { VendorId: Number },
  methods: {
    saveVendor() {
      var vm = this;
      this.$store
        .dispatch(ACTIONS.VENDOR_COMMODITY_SAVE, {
          ParentId: vm.VendorId,
          Commodities: vm.AddedCommodity
        })
        .then(res => {
          var { data } = res;
          if (data && data.StatusCode == 200) {
            vm.success_message = "Vendor Added Successfully";
            setTimeout(function() {
              vm.success_message = null;
              vm.CloseModal();
            }, 1500);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    CloseModal() {
      this.$emit("Close");
    },
    CloseModal() {
      this.$emit("Close");
    },

    GetCoomodityById(id) {
      this.VendorCommodities;
      for (var i = 0; i < this.commodities.length; i++) {
        if (this.commodities[i].Id === id) {
          return this.commodities[i];
        }
      }
    },
    addVendorCommodities() {
      //this.selectedCommodity = this;
      if (this.selectedCommodity > 0) {
        var found = false;
        for (var i = 0; i < this.AddedCommodity.length; i++) {
          if (this.AddedCommodity[i].Id == this.selectedCommodity) {
            found = true;
            break;
          }
        }
        if (!found) {
          var commodity = this.GetCoomodityById(this.selectedCommodity);
          this.AddedCommodity.splice(0, 0, commodity);
        }
      }
    },
    removeCommodity(commodity) {
      var index = this.AddedCommodity.indexOf(commodity);
      this.AddedCommodity.splice(index, 1);
    },
    GetData() {
      var Url = "?currentpage=1&pagesize=0&search=";
      this.$store
        .dispatch(ACTIONS.COMMODITY_GETALL, Url)
        .then(res => {})
        .catch(err => {});
    }
  },
  beforeMount() {
    var vm = this;

    if (this.VendorId && this.VendorId) {
      this.AddedCommodity = [...this.VendorCommodities];
      this.GetData();
    }
  },
  computed: {
    ...mapGetters({
      message: "CommodityErrorMessage",
      loading: "commodityLoading",
      TotalRecords: "commodityTotalPage",
      PageSize: "PageSize",
      commodities: "commodities",
      VENDOR: "VendorCommoditiesVendor",
      VendorCommodities: "AllVendorCommodities"
    })
  }
};
</script>